// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    width: '100%',
    margin: '20px 0',
  },
  title: {
    display: 'flex',
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    width: 'fit-content',
    alignSelf: 'center',
  },
  description: {
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    padding: '10px 0',
    alignSelf: 'flex-start',
  },
  rejectTitleContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginBottom: 10,
  },
  rejectText: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  blueText: {
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
  conditionContainer: {
    padding: '10px 0',
  },
  rejectContainer: {
    marginTop: 25,
  },
  booksSubTitle: {
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginTop: 30,
  }
});

export default styles;
